export default "__VITE_ASSET__B4SGg_Jk__"